import { ColumnDef } from "@shape-ds/components";
import { CellContext } from "@tanstack/table-core";
import { t } from "i18next";
import { DefaultCell } from "../components";

export function acessorFn<T>(data: T, key: keyof T) {
  if (!data[key] || data[key] === "NaT") return "-";

  return data[key];
}
export type BuildColumns<T> = {
  columns: {
    [K in keyof T]?: Partial<ColumnDef<T>> & {
      accessorFn?: (data: T, key: keyof T) => number | string | null;
      i18nkey?: string;
      getClassName?: (text: string) => string;
    };
  };
  getLabel?: (key: string) => string;
  overrideColumns?: string[];
};

const getFilterLabel = (filterOption: string, i18nkey?: string) => {
  const defaultOption = filterOption === "ALL" || filterOption === "-";
  const key = defaultOption
    ? `components:table.${filterOption}`
    : `${i18nkey}.${filterOption}`;
  return t(key, { defaultValue: filterOption });
};

export function buildColumnsObject<T>({
  columns,
  getLabel,
  overrideColumns,
}: BuildColumns<T>) {
  const columnsKeys = (overrideColumns ?? Object.keys(columns)) as (keyof T)[];
  return columnsKeys.map((key) => {
    const {
      enableColumnFilter,
      i18nkey,
      cell: columnCell,
      getClassName,
      accessorFn,
    } = columns[key] || {};
    const filterProps = enableColumnFilter
      ? {
          enableColumnFilter: true,
          filterFn: "arrIncludesSome",
          meta: {
            getFilterLabel: (filterOption: string) =>
              getFilterLabel(filterOption, columns[key]?.i18nkey),
          },
        }
      : { enableColumnFilter: false };

    const defaultCell =
      !columnCell && !accessorFn
        ? {
            cell: (cell: CellContext<T, unknown>) =>
              DefaultCell?.({
                text: cell.row.original[key]
                  ? String(cell.row.original[key])
                  : null,
                i18nkey,
                className: getClassName?.(cell.row.original[key] as string),
              }),
          }
        : {};

    return {
      id: key,
      header: getLabel ? getLabel(key.toString()) : key,
      accessorFn: (data: T) => acessorFn(data, key as keyof T),
      ...defaultCell,

      ...filterProps,
      ...columns[key],
    };
  });
}
